import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import colors from '../Theme/colors';

const mailPropertyTypes = {
  dPath: PropTypes.string,
  title: PropTypes.string,
  fill: PropTypes.string,
};

type MailProperties = InferProps<typeof mailPropertyTypes>;

const Mail = ({
  fill, ...properties
} : MailProperties) => (
  <EmailOutlined
    titleAccess="Mail"
    htmlColor={fill ?? colors.greyDark}
    {...properties}
  />
);

Mail.propTypes = mailPropertyTypes;

export default Mail;
